import { observable, runInAction } from "mobx"

import { fetchGetMagazinesById } from "~/api/magazines/[id]/get"
import { fetchGetMagazines } from "~/api/magazines/get"
import { Magazine } from "~/entities/Magazine"

export default class MagazineStore {
  @observable magazine: Magazine | null = null
  @observable magazines: Array<Magazine> = []

  fetch = async (number?: number): Promise<Magazine[]> => {
    const magazines = await fetchGetMagazines()
    const data = magazines.data.map((datum) => {
      return new Magazine(datum as any)
    })
    runInAction(() => {
      this.magazines = data
    })
    return number === undefined ? this.magazines : this.magazines.slice(0, number)
  }

  fetchById = async (id: number): Promise<Magazine | null> => {
    const magazine = await fetchGetMagazinesById(id)
    if (!magazine || !magazine.id) {
      return null
    }
    runInAction(() => {
      this.magazine = new Magazine(magazine as any)
    })
    return this.magazine
  }

  fetchByCompanyId = async (id: number): Promise<Magazine[]> => {
    const magazines = await fetchGetMagazines({ company_id: id })
    const data = magazines.data.map((datum) => {
      return new Magazine(datum as any)
    })
    runInAction(() => {
      this.magazines = data
    })
    return this.magazines
  }
}
